import React from "react";

export const Brand = ({ variant = "dark", size = "md" }) => {
  const isDark = variant === "dark";
  const sizes = {
    sm: { box: "h-8 w-8", txt: "text-lg" },
    md: { box: "h-10 w-10", txt: "text-xl" },
    lg: { box: "h-12 w-12", txt: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <div
        className={`brand-icon-frame ${s.box} relative flex items-center justify-center rounded-md`}
        style={{
          background: isDark ? "#0F172A" : "#FFFFFF",
          border: isDark ? "1px solid #1E293B" : "1px solid #E2E8F0",
        }}
      >
        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 10l9-7 9 7" />
          <path d="M5 10v10h14V10" />
          <path d="M9 20v-6h6v6" />
        </svg>
      </div>
      <div className="leading-tight">
        <div className={`font-display font-semibold tracking-tight ${s.txt} ${isDark ? "text-slate-900" : "text-white"}`}>
          Brickstok
        </div>
        <div className="overline" style={{ color: isDark ? "#64748b" : "#94a3b8" }}>AJBN Connect</div>
      </div>
    </div>
  );
};

export default Brand;
